import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Button as ButtonMui } from '@mui/material';
import { BootService } from '@/services/boot';
import { Timeline } from './interfaces/timeline';
import {
  ChatOutlined,
  CheckOutlined,
  CloseOutlined,
  HandshakeOutlined,
  InfoOutlined,
  ReceiptOutlined,
  EditOutlined,
  ContentCopyOutlined,
} from '@mui/icons-material';
import { environments } from '@/environment';

export const useWindowSize = () => ({
  isWiderThanMd: true,
});

export const useAnalyticEvents = (s1: string) => ({
  sendAnalyticEvent: (s2: string, d: unknown) => {
    s1;
    s2;
    d;
  },
});

export const scrollTo = (s1: string) => {
  s1;
};

export const Button: React.FC<{
  variant: string;
  size: string;
  onClick: () => void;
  children: string;
}> = ({ onClick, children }) => {
  return (
    <ButtonMui
      variant="outlined"
      size="medium"
      onClick={onClick}
    >
      {children}
    </ButtonMui>
  );
};

export const Icon: React.FC<{
  className: string;
  name: string;
}> = ({ className, name }) => {
  const sx = { width: '100%', height: '100%' };
  return (
    <span className={className}>
      {name === 'info' && <InfoOutlined sx={sx} />}
      {name === 'chat' && <ChatOutlined sx={sx} />}
      {name === 'checkmark' && <CheckOutlined sx={sx} />}
      {name === 'cross-x-thick' && <CloseOutlined sx={sx} />}
      {name === 'handshake' && <HandshakeOutlined sx={sx} />}
      {name === 'invoice-default' && <ReceiptOutlined sx={sx} />}
      {name === 'edit-16' && <EditOutlined sx={sx} />}
      {name === 'duplicate-default' && <ContentCopyOutlined sx={sx} />}
    </span>
  );
};

export function useTimelineQuery(productId: number, orderId: number | null) {
  const { isFetching, data, refetch, error } = useQuery({
    queryKey: ['TIMELINE_REQUEST_KEY', orderId, productId],
    queryFn: () =>
      BootService.axios({
        url: orderId
          ? `/contents/timeline/buyer?order=${orderId}&product=${productId}&version=3&dataVersion=2`
          : `/contents/timeline/seller?product=${productId}&version=3&dataVersion=1`,
        baseURL: environments[BootService.env].timelineBaseUrl,
      }),
    staleTime: 0,
    cacheTime: 0,
  });

  const isErrorTimeline = error != null;
  const timeline: Timeline = data?.data.data;

  return { isErrorTimeline, isLoadingTimeline: isFetching, timeline, refetchTimeline: refetch };
}
